// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__nSuXm","modal_close":"Modal_modal_close__A2wId","modal_header":"Modal_modal_header__41Crz","btn_close":"Modal_btn_close__3QMW1"};